import React from 'react';
import { theme } from '../theme';
import { CrossIcon } from './shared';

// "N ausgewählt × …" header chip. Auto-hides when count = 0 so the surrounding
// header doesn't reserve space for an empty slot.
export const SelectionStrip: React.FC<{
  count: number;
  onClear: () => void;
}> = ({ count, onClear }) => {
  if (count === 0) return null;
  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: 8,
      padding: '4px 10px', fontSize: 12,
      color: theme.colors.navyMid, backgroundColor: theme.colors.bgLight,
      borderRadius: theme.borderRadius.sm,
      animation: 'stx-fadeIn 0.15s ease',
    }}>
      {count} ausgewählt
      <button onClick={onClear}
        style={{
          background: 'none', border: 'none', cursor: 'pointer',
          padding: 0, display: 'inline-flex', alignItems: 'center',
        }}
        aria-label="Auswahl aufheben">
        <CrossIcon size={12} color={theme.colors.navyMuted} />
      </button>
    </div>
  );
};
